import React from 'react';
import Text from '@rexlabs/text';

export default (props) => <Text is='p' {...props} type={['OPTION_LABEL']} />;
